import * as React from 'react';
import { Logo } from './logo';
import { media, style } from 'typestyle';
import {
  betweenJustified, center, horizontal, horizontallySpaced, inlineRoot, startJustified, vertical,
  verticallySpaced, content, start, wrap
} from 'csstips';
import { em, px } from 'csx';
import { mediaTablet, mediaMobileOnly } from '../theme/media';
import { SVGIcon, SVGIconProps } from './svg-icon';
import { observer } from 'mobx-react';
import { resetAnchorStyles } from '../theme/reset';
import { colorWhite } from '../theme/color';
import { StripeLogo } from './stripe-logo';
import {ResponsiveImageTile} from './responsive-image-tile';
import {ResponsiveImage} from './responsive-image';
import {Component, deps, inject} from '../lib/component';

export interface AppFooterCopyrightProps {
  onClickLink(event: React.MouseEvent<any>): void;
  youTubeImage: string;
  abbeyRoadImage: string;
  logoImage: string;
  midemImage: string;
  Follow: any;
  i18n?: {
    copyright: string;
    tagline: string;
  }
}

@inject(deps) @observer
export class AppFooterCopyright extends Component<AppFooterCopyrightProps> {
  render() {
    const { i18n = AppFooterCopyright.i18n, youTubeImage, abbeyRoadImage, logoImage, midemImage, onClickLink, Follow } = this.props;
    const {preloadRaw} = this.props.controller.image;

    return (
      <div className={AppFooterCopyright.styles.container}>
        <div className={AppFooterCopyright.styles.social}>
          <div className={AppFooterCopyright.styles.certifications}>
            <a target="_blank" href="https://www.youtube.com" onClick={onClickLink}>
              <ResponsiveImage
                identity={youTubeImage}
                preload={preloadRaw}
              />
            </a>
            <a target="_blank" href="https://www.abbeyroad.com/abbeyroadred" onClick={onClickLink}>
              <ResponsiveImage
                identity={abbeyRoadImage}
                preload={preloadRaw}
              />
            </a>
            <a target="_blank" href="http://www.midem.com/en/music-events/midemlab/" onClick={onClickLink}>
              <ResponsiveImage
                identity={midemImage}
                preload={preloadRaw}
              />
            </a>
            <StripeLogo type="light"/>
          </div>
        </div>
        <div className={AppFooterCopyright.styles.copyright}>
          <div>&copy; {i18n.copyright} - {i18n.tagline}</div>
        </div>
      </div>
    )
  }

  static i18n = {
    copyright: `${new Date().getFullYear()} Lickd limited`,
    tagline: 'Real Artists. Real Music. Claims Free. For YouTube.'
  };

  static styles = {

    container: style(

    ),
    social: style(

    ),
    certifications: style(
      {
        ...horizontal,
        ...center,
        ...content,
        ...wrap,
        justifyContent: 'center',
        $nest: {
          '& > *': {
            ...inlineRoot,
          },
          '& img': {
            height: px(40)
          }
        }
      },
      verticallySpaced(20),
      horizontallySpaced(20),
    ),
    socialLink: style({
      display: 'inline-flex',
      color: colorWhite.toString(),
      textDecoration: 'none',
      $nest: {
        ...resetAnchorStyles()
      }
    }),
    copyright: style(
      {
        $nest: {
          '& a': {
            ...inlineRoot,
          },
          '& a img': {
            height: px(30)
          },
          '&> div': {
            fontSize: px(12),
            lineHeight: em(1.1),
            textAlign: 'center'
          },
          '& svg': {
            width: 'auto',
            height: px(48)
          }
        }
      },
    )
  }
}